import React from 'react';
import {
  string,
  shape,
  number,
  object,
  bool
} from 'prop-types';
import { useStore } from '@thd-nucleus/experience-context';
import { TileHead } from '../TileHead';
import { TileFooter } from '../TileFooter';
import { formatDistance, showBopisDate } from '../../../helper/utils';

const InStockNearByStore = ({ nearByStoreLocation, storeHoursCart, isCartTiles }) => {
  // Need to use the nearbyStoreHours from the API once in place and remove the useStore .
  // Until then we are taking storeHours from the experience-context.
  const { storeHours } = useStore();
  const sHours = isCartTiles ? storeHoursCart : storeHours;
  return (
    <div className="fulfillment-tile">
      <TileHead title="Pickup Nearby" />
      <div className="fulfillment__sub-title">
        <div className="u__bold">{showBopisDate(sHours)}</div>
        <div className="u__text--success fulfillment-qty-row">
          {`In stock ${formatDistance(nearByStoreLocation?.distance)} mi away`}
        </div>
      </div>
      <TileFooter className="u__bold">
        <span className="u__text--success">FREE</span>
      </TileFooter>
    </div>
  );
};
InStockNearByStore.propTypes = {
  nearByStoreLocation: shape({
    storeName: string,
    distance: number
  }).isRequired,
  /* eslint-disable-next-line react/forbid-prop-types */
  storeHoursCart: object.isRequired,
  isCartTiles: bool
};

InStockNearByStore.defaultProps = {
  isCartTiles: false
};

export { InStockNearByStore };
